import QRCodeIcon from './component'

export default QRCodeIcon
